import { render, staticRenderFns } from "./UpcomingVideos.vue?vue&type=template&id=0e4d2c1e&scoped=true&"
import script from "./UpcomingVideos.vue?vue&type=script&lang=js&"
export * from "./UpcomingVideos.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingVideos.vue?vue&type=style&index=0&id=0e4d2c1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4d2c1e",
  null
  
)

export default component.exports